import React from "react";

export default function Footer () {
    return (
        <div className="Footer">
            <footer>
                Coded by Runeiva. Hosted on <a href={"https://webdictionary-app.netlify.app/"}>Netlify</a>.
            </footer>

        </div>
    )

}
